export enum ComponentGroupType {
    Company = 1,
    Property = 2
}